export const AD_ROTATION_SECONDS = 10;
export const AD_POOL_LIMIT = 10;
export const AD_POOL_REFRESH_SECONDS = 120;
